var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"spinner",style:(_vm.loaderSize)},_vm._l((_vm.count),function(item){return _c('div',{key:item,staticClass:"spinner-item",style:(_vm.roundSize)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }